import { featureFlagKeySchema } from "@redotech/feature-flags-model/schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getTeamFeatureFlagArm = {
  name: "getTeamFeatureFlagArm" as const,
  input: z.object({ teamId: zExt.objectId(), flagKey: featureFlagKeySchema }),
  output: z.object({ value: z.boolean() }),
};
